function addReviewSnippets() {
    let data = {
        '@context': 'http://schema.org',
        '@type': 'LocalBusiness',
        'name': window.WPURLS.sitetitle,
        'image': $('.header__logo img').attr('src'),
    };

    data['aggregateRating'] = {
        '@type': 'AggregateRating',
        'ratingValue': $('.about').data('service-rating'),
        'ratingCount': $('.about').data('review-count'),
    };

    var el = document.createElement('script');
    el.type = 'application/ld+json';
    el.text = JSON.stringify(data);

    document.querySelector('head').appendChild(el);
}

export default {
    init() {
        addReviewSnippets();

        $(window).resize(function() {
            $('.js-special-offers-slider.slick-initialized').slick('resize');
        });

        $('.js-special-offers-slider').slick({
            autoplay: true,
            fade: true,
        });
    },
    finalize() {
        
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js